import { apiAxios } from '@app/api-client';
import type {
  DemoPrefillInput,
  DemoPrefillResponse,
  DemoResetInput,
  DemoResetResponse,
  DemoSeedProcessCartographyResponse,
  DemoStatus,
} from '@app/contracts';

export const fetchDemoStatus = async (): Promise<DemoStatus | null> => {
  try {
    return await apiAxios<DemoStatus>({ url: '/api/v1/demo/status', method: 'GET' });
  } catch {
    return null;
  }
};

export const resetDemo = (input: DemoResetInput): Promise<DemoResetResponse> =>
  apiAxios<DemoResetResponse>({ url: '/api/v1/demo/reset', method: 'POST', data: input });

export const prefillDemo = (input: DemoPrefillInput): Promise<DemoPrefillResponse> =>
  apiAxios<DemoPrefillResponse>({ url: '/api/v1/demo/prefill', method: 'POST', data: input });

export const seedDemoProcessCartography = (): Promise<DemoSeedProcessCartographyResponse> =>
  apiAxios<DemoSeedProcessCartographyResponse>({
    url: '/api/v1/demo/seed-process-cartography',
    method: 'POST',
  });
